import React , { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import app from "./app" 
import {svgIcon, isUploadedIcon, isUnsafeHref} from "./utility";

const HtmlTag = function (props) {
  switch (props.tag) {
    case "h1":
      return <h1 {...props} dangerouslySetInnerHTML={{ __html: props.text }} />;
    case "h2":
      return <h2 {...props} dangerouslySetInnerHTML={{ __html: props.text }} />;
    case "h3":
      return <h3 {...props} dangerouslySetInnerHTML={{ __html: props.text }} />;
    case "h4":
      return <h4 {...props} dangerouslySetInnerHTML={{ __html: props.text }} />;
    case "h5":
      return <h5 {...props} dangerouslySetInnerHTML={{ __html: props.text }} />;
    case "h6":
      return <h6 {...props} dangerouslySetInnerHTML={{ __html: props.text }} />;
    default:
      return <div {...props} dangerouslySetInnerHTML={{ __html: props.text }} />;
  }
}

export function clickInternalLink(e) {
  if(e.currentTarget.getAttribute("href")) {
    if(e.currentTarget.getAttribute("href").indexOf("/") === 0) {
      window.routerClick(e);
      e.preventDefault();
    }
  }
}

// Match a row by either key: menu items store a pageId, but some rows are
// referenced by their pageIdentifier ("homenew", "hyperstore", …) instead.
function matchesPageRef(row, ref) {
  return !!row && (row.pageId === ref || row.pageIdentifier === ref);
}

// Find a page by pageId/pageIdentifier anywhere in the tree, carrying the
// parent's path down so a folder child resolves to "/parent/child".
// Returns { page, parentUrl }.
function findPageById(list, pageId, parentUrl) {
  const rows = Array.isArray(list) ? list : [];
  for (let i = 0; i < rows.length; i++) {
    const p = rows[i];
    if (!p) continue;
    if (matchesPageRef(p, pageId)) return { page: p, parentUrl: parentUrl || "" };
    const kids = p.folderPages || p.children;
    if (Array.isArray(kids) && kids.length) {
      // Accumulate onto the path built so far, not just this row's slug —
      // folders nest more than one level deep (the live nav has a folder inside
      // a folder), and resetting here would drop every ancestor above the
      // parent. Home contributes nothing, so a child of home is "/child".
      const isHome = p.pageIdentifier === "home" || p.pageIdentifier === "homenew";
      const hit = findPageById(kids, pageId, isHome ? "" : `${parentUrl || ""}/${p.pageUrl}`);
      if (hit) return hit;
    }
  }
  return null;
}

export function ImageGenerated(props) {
  const [status, setStatus] = useState(false);
  const [success, setSuccess] = useState(false);
  const readyImages = function(type, image) {
    let data = [];
    if(localStorage.getItem("aiReadyImages")) {
        data = JSON.parse(localStorage.getItem("aiReadyImages"))
    }
    if(type === "p") {
        data.push(image);
        localStorage.setItem("aiReadyImages", JSON.stringify(data));
    }
    else {
        return ((data.indexOf(image) !== -1)?true:false)
    }
}
  const checkDefault = function() {
      if(props.src) {
          if(props.src.indexOf("media.mediadirhub.com") !== -1) {
              return true;
          }
          if(props.src.indexOf("/ai-generated/") !== -1) {
              return true;
          }
      }
      return false;
  }
  useEffect(() => {
      if(!checkDefault()) {
          const a = setInterval(function(){
          if(readyImages("c", props.src)) {
              clearInterval(a);
              updateSuccess(true);
          }
          }, 1000);
          if(readyImages("c", props.src)) {
              clearInterval(a);
              updateSuccess(true);
          }
      }
   }, []);
  
   const updateSuccess = function() {
      setSuccess(true);
       setTimeout(function(){
          setStatus(true);
       }, 600)
   }
   let style = JSON.parse(JSON.stringify(props.style));
   if(status) {
   style["backgroundImage"] = `url(${props.src})`;
  }
   
  return <div className={`${props.rootClass} ${success?'image-success':''}  ${status?'image-ready':''}`} style={props.rootStyle}>
    <img className={props.className} style={style} alt={props.alt} src={`https://media.mediadirhub.com/images/image-${props.ratio}.png`}  />
    <div className="loader-wrapper d-flex align-items-center justify-content-center">
    <span className="new-loader sm-loader"></span>
    </div>
    <span className="generating">generating</span>
    <span className="succeeded">succeeded</span>
  </div>
}

const changeTimeTo12HourFormat = function(time, _twentyFourHourCheck, lang) {  
    if (_twentyFourHourCheck == "1") {
      return time
    }
    else { 
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' '+lang.am : ' '+lang.pm; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(''); // return adjusted time or original string
    }
}

const getMapImg = function(data, mode, style, apiKey) { 
  if(app.getMode(mode)){
    if(data.text && apiKey){
      return <img width="100%" style={style} src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(data.text)}&zoom=13&scale=2&size=600x300&maptype=roadmap&format=png&key=${"AIzaSyCjYOJpK9plPZqa635QER2zM8vm3s0284E"}`} alt={data.text}/>
    }
    else{
      return <img width="100%" style={style} src="https://mediadirhub.com/samples/map.png"/>
    }
  }else{
    return <img width="100%" style={style} src="https://mediadirhub.com/samples/map.png"/>
  } 
}

export function Elements(props) { 
    let html = "";
    const list  = props.row;
    const data  = props.data;
    const type = `elements ${app.getClass(list, props.device)}`;
    const style = app.getStyle(list, props.device);
    const headerIcon = props.icon; 

    const [currentAddress, setCurrentAddress] = useState("");

    useEffect(() => { 
        if (typeof window !== "undefined") {
          const addressData = window.localStorage.getItem("addressData");
          if (addressData) {
            const city = JSON.parse(addressData).currentCity;
            setCurrentAddress(city);
          }
        } 
    }, []);
    
    if(!list) {
      return <div className="item-not-found d-none">No Data Found</div>
    }

    if(list.viewType === "input"){
      
      let fieldType = list.properties.type;
      let placeholder = list.text

      if(fieldType === "textarea"){
        html = <textarea id={props.id} rows="4" placeholder={placeholder} style={style} className={`${type} w-100 ${props.classType}`}></textarea>
      }
      else{
        html = <input id={props.id} type={fieldType} style={style}  placeholder={placeholder} className={`${type} w-100 ${props.classType}`} />
      }
    }
    
    if(list.viewType === "text"){
        let icon = "" 
        if(list.properties.media){
            if(list.properties.media.show){
                if(list.properties.media.type === "icon"){
                    icon = <i className={`icons me-3 fa ${list.properties.media.src}`}/>
                }else{
                    icon = <img className="img me-3" src={`https://media.mediadirhub.com/images/image-1x1.png`} style={{background:'URL('+list.properties.media.src+') no-repeat center/cover'}}/> 
                }
            }   
        }
        // html = <h2 id={id} className={`${type} m-0 text-${list.properties.textAlignment}`} style={style} >{icon}<span>{list.text}</span></h2>
        if(props.mode === "live") {
          html = <HtmlTag id={props.id} className={`text-break m-0 ${type} ${props.classType}`} style={style} text={list.text} tag={list.properties.tagType} />
        }
        else {
          html = <div id={props.id} className={`text-break m-0 ${type} ${props.classType}`} style={style} dangerouslySetInnerHTML={{__html:list.text}}/>
        }
      }

    if(list.viewType === "textHtml"){
      
      if(list.contentType === "location"){ 
        if(props.device === "mobile" && props.map) {
          if(list.properties.isMap == true){
            html = getMapImg(list, props.mode, style, true)
          } 
        }
        else{
          if(!props.map){
            html =  html = <div id={props.id} className={`text-break ${type} ${props.classType}`} style={style} dangerouslySetInnerHTML={{__html:list.text}} />
          } 
        } 
      }
      // else if(props.parentType === "headerText"){
      //   html = <div id={props.id} className={`text-break ${type} ${props.classType}`} style={style} dangerouslySetInnerHTML={{__html:list.text}} />
      // }
      else{
        if(props.mode === "live") {
          html = <HtmlTag id={props.id} className={`text-break ${type} ${props.classType}`} style={style} text={list.text} tag={list.properties.tagType} />
        }
        else {
          html = <div id={props.id} className={`text-break ${type} ${props.classType}`} style={style} dangerouslySetInnerHTML={{__html:list.text}} />
        }
      } 
    } 

    if(list.viewType === "copyRight"){ 
      html = <div id={props.id} className={`text-break ${type} ${props.classType}`} style={style} dangerouslySetInnerHTML={{__html:list.text}} />
    } 

    if(list.viewType === "button"){ 
      let cornerType = '0px'
      if(list.properties.cornerType === 'circular'){
        cornerType = '100px'
      }
      else if(list.properties.cornerType === 'rounded'){
        if(props.device === "desktop") {
          cornerType = app.elementPadding(list.properties.cornersWeb);
        }
        else {
          cornerType = app.elementPadding(list.properties.corners);
        } 
      } 
      
      let margin = ""
      if(list.properties.marginWeb){
        if(props.device === "desktop") {
          margin = app.elementPadding(list.properties.marginWeb);
        }
        else {
          margin = app.elementPadding(list.properties.margin);
        } 
      } 
      
      style["borderRadius"] = cornerType; 
      style["margin"] = margin;  

      
      if(data && data.properties.elementSpacing && data.properties.elementSpacing !== undefined){
        if(props.device === "desktop"){
          style["margin"] = '0';
          style["marginLeft"] = data.properties.elementSpacing/2+'vw'; 
          style["marginRight"] = data.properties.elementSpacing/2+'vw'; 
        }  
      }
     
      let target = null;
      if(list.properties.target === true) {
        target = "_blank";
      }
      if(list.properties.link.indexOf("javascript:") !== -1) {
        target = null;
      }

      let href = null;
      if(list.properties.link){
        href = list.properties.link
      }
      else if(props.parent && props.parentType === "login"){
        href = 'login'
      } 
     
      if(app.getMode(props.mode)){
        html = <a data-show={list.properties.showWeb} id={props.id} className={list.properties.link?`position-relative text-break ${type}  btn mx-2 ${props.classType?props.classType:''}`:`position-relative text-break ${type}  btn ${props.classType?props.classType:''} cursor-default`} href={href} target={target} style={style} dangerouslySetInnerHTML={{__html:list.text}}/>
      }else{
        html = <div data-show={list.properties.showWeb} id={props.id} className={list.properties.link?`position-relative text-break ${type}  btn mx-2 ${props.classType?props.classType:''}`:`position-relative text-break ${type}  btn ${props.classType?props.classType:''} cursor-default`} style={style} dangerouslySetInnerHTML={{__html:list.text}}/>
      }
     
    } 

    if(list.viewType === "image"){
      let scaleType = 'cover'
      if(props.device === "desktop") {
        if(list.properties.scaleTypeWeb === 'CENTER_INSIDE'){
          scaleType = 'contain'
        }else if(list.properties.scaleTypeWeb === 'FIT_XY'){
          scaleType = 'fill'
        }
      }else{
        if(list.properties.scaleType === 'CENTER_INSIDE'){
          scaleType = 'contain'
        }else if(list.properties.scaleType === 'FIT_XY'){
          scaleType = 'fill'
        }
      }
      

      let cornerType = ''
      if(list.properties.cornerType === 'circular'){
        cornerType = '100%'
      }else if(list.properties.cornerType === 'rounded'){ 
        if(props.device === "desktop") {
          cornerType = app.elementPadding(list.properties.cornersWeb);
        }
        else {
          cornerType = app.elementPadding(list.properties.corners);
        } 
      }

      let alt = "";
      if(list.properties.alt){
        alt = list.properties.alt;
      }
      let aiClass = "";
      // if(list.properties.src.indexOf("/ai-generated/") !== -1) {
      //   aiClass = "ai-generated";
      // }
      if(list.properties.src){
        if(list.properties.src.indexOf("/ai-generated/") !== -1) {
          aiClass = "ai-generated";
        }
      }
      
      let aLink = "";
      if(list.properties.link){
        let target = null;
        if(list.properties.target === true) {
          target = "_blank";
        }
        if(list.properties.link.indexOf("javascript:") !== -1) {
          target = null;
        }
        aLink = <a className="anchor-link" href={list.properties.link?list.properties.link:null} target={target}></a>
      }

      let imageRatio = list.properties.ratio;

      let isMobileImg = "";
      let isDesktopImg = ""

      if(!list.properties.show){
        isMobileImg = "mobile-d-none" 
      }
      if(!list.properties.showWeb){
        isDesktopImg = "desktop-d-none"
      }

      if(props.device === "desktop") { 
        if(list.properties.ratioWeb){ 
          imageRatio = list.properties.ratioWeb;
        }
      }
      if(app.aiGenerated(props.mode, list.properties.src)) {
        html = <ImageGenerated 
        ratio={imageRatio}
        src={list.properties.src}
        className={`${type} w-100`} 
        style={{backgroundPosition:"center", backgroundSize:scaleType, backgroundRepeat:"no-repeat", borderRadius:cornerType, border:list.properties.borderColor?`1px solid ${app.getColor(list.properties.borderColor)}`:null}} 
        alt={alt}
        rootClass={`position-relative overflow-hidden w-100 ${props.classType} ${isMobileImg} ${isDesktopImg} ${aiClass}`} 
        rootStyle={{padding:app.elementPadding(list.properties.paddingWeb), background:app.elementBackground(list.properties.background, list.properties.backgroundType)}} 
        /> 
      }
      else {
        html = <div className={`position-relative w-100 aspect-ratio-wrap ${props.classType} ${isMobileImg} ${isDesktopImg} ${aiClass}`} style={{padding:app.elementPadding(list.properties.paddingWeb), background:app.elementBackground(list.properties.background, list.properties.backgroundType),aspectRatio : imageRatio.replace(/x/,"/")}}>
          <img id={props.id} src={list.properties.src} alt={alt} className={`${type} w-100 h-100`} style={{borderRadius:cornerType, border:list.properties.borderColor?`1px solid ${app.getColor(list.properties.borderColor)}`:null,objectFit : scaleType}} />
          {aLink}
        </div>
      } 
    }
 
    if(list.viewType === "socialLinks"){ 
        let memberSocialInfo = ""
        if(list.options){
            memberSocialInfo = list.options.map(function(v, i){
                if(isUploadedIcon(v.iconCss)) {
                    return <a href={v.link} className="fa" target={v.link?"_blank":null} key={'key-'+i} style={{background:app.getColor(list.properties.iconBackground)}}><img src={v.iconCss} alt="" className="uploaded-icon" /></a>
                }
                return <a href={v.link} className={'fa '+v.iconCss} target={v.link?"_blank":null} key={'key-'+i} style={{color:app.getColor(list.properties.iconColor), background:app.getColor(list.properties.iconBackground)}}></a>
            })
        }
        html = <div id={props.id} className={`${type} social d-flex justify-content-${list.properties.iconAlignment} align-items-center`} style={style}>{memberSocialInfo}</div>
    } 
    if(list.viewType === "list"){ 
      return <div id={props.id} className={`${type} list`} style={style}>
       {
         list.data.map(function(v){
           return  <div className={`w-100 item-list d-flex justify-content-${list.properties.textAlignment}`}>
           {isUploadedIcon(v.icon)
             ? <i className="p-1" style={{background:app.getColor(list.properties.iconBackground)}}><img src={v.icon} alt="" className="uploaded-icon" /></i>
             : <i className={`p-1 ${v.icon}`} style={{color:app.getColor(list.properties.iconColor), background:app.getColor(list.properties.iconBackground)}}></i>}<span className="p-1 d-inline-block">{v.text}</span></div>
         })
       }
      </div>
    } 
    if(list.viewType === "skills"){ 
      return <div id={props.id} className={`${type} skills`} style={style}>
       {
         list.data.map(function(v){
           return  <div className={`w-100 item-list d-flex flex-wrap justify-content-${list.properties.textAlignment}`}>
             <div className="d-flex w-100 mb-2">
              <span className="py-1 d-inline-block">{v.text}</span>
              <span className="py-1 d-inline-block ms-auto">{v.level} %</span>
             </div>
             <div className="progress mb-3 w-100" style={{backgroundColor:app.getColor(list.properties.trackColor)}}>
              <div className="progress-bar" style={ {backgroundColor:app.getColor(list.properties.fillColor),  "width": `${v.level}%`}}></div>
            </div>
           </div>
         })
       }
      </div>
    } 

    if(list.viewType === "tags"){ 
      return <div id={props.id} className={`${type} tags`} style={style}>
       {
         list.data.map(function(v){
          return  <span className="tag-badge " style={{fontSize:(props.device === "desktop"?list.properties.textSizeWeb:list.properties.textSize) + "px", color:app.getColor(list.properties.tagColor), background:app.elementBackground(list.properties.tagBackground, list.properties.tagBackgroundType), border:app.getBorder(list.properties)}}>{v.text}</span>
         })
       }
      </div>
    } 
    

    if(list.viewType === "pricingPlanPrice"){ 
      let currency = list.properties.currency;
      let price = list.text === "" ? "0" : list.text;
      let plan = list.properties.planType;
      let planText = list.properties.planText === "" ? "" : list.properties.planText;

      return <div id={props.id} className={`${type} list fw-bold justify-content-${list.properties.textAlignment}`} style={style}>
        <sup>{currency}</sup> <span>{price}</span> <sub> /{plan === "other" ? planText : plan}</sub>
      </div>
    } 

    if(list.viewType === "menu"){ 
      html = <nav id={props.id} className={`navbar navbar-expand-lg navbar-light bg-light ${type} ${props.classType}`}>
      <div className="container-fluid">
    
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link active" href="#">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">Features</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">Pricing</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    } 
    

    if(list.viewType === "hours"){ 
      const lang = props.root.lang;  
      let workingHours = "";  
      if (list) {   
          if(list.alwaysOpen == "1"){
              workingHours = <div className={`d-flex justify-content-${list.properties.textAlignment}`}>{lang.open_24_7}</div>
          }
          else{
              workingHours = [
                "mon",
                "tue",
                "wed",
                "thu",
                "fri",
                "sat",
                "sun"  
              ].map(function(key, ind){ 
                var a = list.workingHours[ind]; 
                return <div className={`d-flex justify-content-${list.properties.textAlignment}`} key={'key-'+ind}>
                  <div style={{minWidth:'100px'}}>{lang?lang[a.day]:null}</div>
                  <ul className="p-0 px-3" style={{minWidth:'100px'}}>
                      {a.duration.length?
                          a.duration.map(function (k, j) { 
                            if(k.alwaysFrom){
                              return <li className="d-flex" key={j}>
                                  <span>{changeTimeTo12HourFormat(k.alwaysFrom, list.applyTwentyFourFormat, lang)}</span>
                                  <span className="mx-2">-</span>
                                  <span >{changeTimeTo12HourFormat(k.alwaysTo, list.applyTwentyFourFormat, lang)}</span>
                              </li>
                            } 
                          })
                      :lang.closed}
                  </ul> 
              </div> 
              })
               
          }
          
          html = <div id={props.id} className={`w-100 ${type}`} style={style}> 
              {workingHours} 
          </div> 
      }
    } 
    if(list.viewType === "icon"){ 
      // let p = eval(list.properties.padding.split(',').join('+'));
      // let f =  eval(list.properties.iconSize);  
      let p = list.properties.padding.split(',').reduce((a, b) => parseInt(a) + parseInt(b), 0);
      let f =  parseInt(list.properties.iconSize);  
      if(props.device === "desktop") {
        // f =  eval(list.properties.iconSizeWeb);  
        // p = eval(list.properties.paddingWeb.split(',').join('+'));
        p = list.properties.paddingWeb.split(',').reduce((a, b) => parseInt(a) + parseInt(b), 0);
        f = parseInt(list.properties.iconSizeWeb);
      }
      let cornerType = ''
      if(list.properties.cornerType === 'circular'){
        cornerType = '100%'
      }
      else if(list.properties.cornerType === 'rounded'){
        if(props.device === "desktop") {
          cornerType = app.elementPadding(list.properties.cornersWeb)
        }else{
          cornerType = app.elementPadding(list.properties.corners)
        }
        
      } 
 
      let paddingTotal = 0;
      let iconSizeTotal = 0;
      if(p){
        paddingTotal = p
      }
      if(f){
        iconSizeTotal = f
      }
      
      style["width"] = paddingTotal+iconSizeTotal; 
      style["maxWidth"] = paddingTotal+iconSizeTotal; 
      style["height"] = paddingTotal+iconSizeTotal; 
      style["borderRadius"] = cornerType; 
      
      if(data && data.properties.elementSpacing && data.properties.elementSpacing !== undefined){
        if(props.device === "desktop"){
          style["marginLeft"] = data.properties.elementSpacing/2+'vw'; 
          style["marginRight"] = data.properties.elementSpacing/2+'vw'; 
        } 
      }
  
      // let iconbase = <i id={props.id} className={`${type}  icons ${list.properties.iconCode} `} style={style}></i>;
      // if(list.properties.iconCode.indexOf('https://') !== -1){
      //   iconbase = <img id={props.id} className={`${type}`} style={style} src={list.properties.iconCode}/>;
      // }

      let iconElement = <i style={{width: "auto", height: "auto", margin: 0, padding: 0, fontSize : style["fontSize"] }} className={`icons ${list.properties.iconCode}`}></i>;

      if(list.properties.iconCode.indexOf('https://') !== -1){
        iconElement = <div style={{width: "auto", height: "auto", margin: 0, padding: 0 }} className={`icons icon-img icon-town-hall`}><img src="https://media.mediadirhub.com/images/image-1x1.png" style={{ background: `url(${list.properties.iconCode})` , borderRadius : `${style["borderRadius"]}`} }/></div>
      }

      let iconbase = <div style={style} id={props.id} className={`${type}`}>{iconElement}</div>;

      let target = null;
      if(list.properties.target === true) {
        target = "_blank";
      }
      if(list.properties.link.indexOf("javascript:") !== -1) {
        target = null;
      }
      html = <div className={`position-relative d-flex justify-content-${list.properties.iconAlignment} ${props.classType}`}>
        {iconbase}
        {list.properties.link && list.properties.iconStatic !== true?<a className={`anchor-link link-overlay`} href={list.properties.link?list.properties.link:null} target={target}></a>:''}
      </div> 
    } 

    if(list.viewType === "contactLinks"){ 
      let itemData = "" 
      if(list.contactItems){
           itemData = list.contactItems.map(function(v, i){
            if(v.type === "textHtml"){ 
              return <div key={'key-'+i} className="d-block text-break">{v.value}</div>
            }
            if(v.type === "url"){ 
              return <a key={'key-'+i} className="d-block text-break" href={v.value}>{v.value}</a>
            }
            if(v.type === "email"){ 
              return <a key={'key-'+i} className="d-block text-break" href={`mailto:${v.value}`}>{v.value}</a>
            } 
            if(v.type === "phone"){ 
              return <a key={'key-'+i} className="d-block text-break" href={`tel:${v.value}`}>{v.value}</a>
            }
            if(v.type === "skype"){ 
              return <a key={'key-'+i} className="d-block text-break" target='_blank' href={`https://skype.com/${v.value}`}>{v.value}</a>
            }
            if(v.type === "whatsapp"){ 
              return <a key={'key-'+i} className="d-block text-break" target='_blank' href={`https://wa.me/${v.value}`}>{v.value}</a>
            }
            if(v.type === "location"){ 
              return <a key={'key-'+i} className="d-block text-break" href={`https://maps.google.com/maps?q=${encodeURIComponent(v.value)}`}>{v.value}</a>
            }
           })
      }
      html = <div id={props.id} className={`${type} m-0 text-${list.properties.textAlignment}`} style={style}>{itemData}</div>
    }

    if(list.viewType === "logo"){  

      let alt = "";
      let aiClass = "";
      if(list.properties.src){
        if(list.properties.src.indexOf("/ai-generated/") !== -1) {
          aiClass = "ai-generated";
        } 
      }

      let isLogo = (props.device === "desktop"?list.properties.showWeb:list.properties.show)
      let isMobileImg = "";
      let isDesktopImg = "";
      let showTitle = "";
      let showTitleWeb = ""

      if(!list.properties.showTitle){
        showTitle = "mobile-d-none" 
      }
      if(!list.properties.showTitleWeb){
        showTitleWeb = "desktop-d-none"
      }
      if(list.properties.showLogo !== undefined) {
        if(!list.properties.showLogo){
          isMobileImg = "mobile-d-none" 
        }
        if(!list.properties.showLogoWeb){
          isDesktopImg = "desktop-d-none"
        }
      }
      
      
      html = <div id={props.id} className={`position-relative w-100 d-flex align-items-center ${type} ${props.classType} ${aiClass} ${isLogo?"":"d-none"}`} style={style}>
        <img src={`${list.properties.src}`} alt={alt} className={`w-auto ${isMobileImg} ${isDesktopImg}`} style={{maxHeight:list.properties.logoDimension+'px'}}/>
        <div dangerouslySetInnerHTML={{__html:list.text}} style={style} className={`logoTitle ${showTitle} ${showTitleWeb}`} data-text={list.text}/>
      </div> 
     
     if(app.getMode(props.mode)){
        html = <a href='/' onClick={(e) => window.routerClick(e)} id={props.id} className={`position-relative w-100 d-flex align-items-center ${type} ${props.classType} ${aiClass} ${isLogo?"":"d-none"}`} style={style}>
          <img src={`${list.properties.src}`} alt={alt} className={`w-auto ${isMobileImg} ${isDesktopImg}`} style={{maxHeight:list.properties.logoDimension+'px'}}/>
          <div dangerouslySetInnerHTML={{__html:list.text}} style={style} className={`logoTitle ${showTitle} ${showTitleWeb}`} data-text={list.text}/>
        </a> 
      }
    }

    if(list.viewType === "navigation"){
      // console.log("navigation", props)
      // plugins-* pages should NOT use the SPA router click handler
      const isPlugin = function(url){ return !!url && url.indexOf("plugins-") !== -1; };
      let row =  props.row;
      let linkStyle = style;  
      if(props.device === "desktop"){
        linkStyle.margin = data.properties.linkSpacing/2+'vw';
      } 
      let subLinkStyle = JSON.parse(JSON.stringify(style));  
      delete subLinkStyle['background'];
      delete subLinkStyle['color'];


      let elementStyle = {};  
      if(data && data.properties.elementSpacing && data.properties.elementSpacing !== undefined){
        if(props.device === "desktop"){
          elementStyle["marginLeft"] = data.properties.elementSpacing/2+'vw'; 
          elementStyle["marginRight"] = data.properties.elementSpacing/2+'vw';
        } 
      } 

      let mAuto = "mx-auto";
      if(data.properties.headerLayout === "3"){
        mAuto = ""
      }

      let others = null;
      let othersText = "Others";
      if(app.getLang("others")) {
        othersText = app.getLang("others");
      }
      
      let pages = [];
      let folders = [];
      let autoLoad = false;
      if(props.appData) {
        pages = props.appData.home;
        // Folders live in their own array alongside home, each row holding its
        // pages in folderPages. Absent in the editor, where props.navigation
        // already carries folderPages nested inside the page rows.
        folders = props.appData.folders;
        if(props.appData.appData) {
          if(props.appData.appData.pwaOption.pwaAutoLoadFirstPage) {
            autoLoad = true;
          }
          othersText = props.appData.languageSetting.Others;
        }

      }
      else {
        pages = props.navigation;
      }

      // Resolve a navigationMenu item's `value` to an href. Closes over `pages`
      // above — the list the header is rendering from (props.appData.home or
      // props.navigation), each row carrying pageId, pageUrl and pageIdentifier.
      //
      // Items created by ManageMenu store the target page's own pageId
      // ("aiarticle_1774343495231_72"), optionally with an anchor
      // ("aiarticle_1774343495231_72#top"), rather than a path — so renaming a
      // page's URL no longer orphans its menu entry.
      //
      // Anything already usable as a link is returned untouched: http(s)/mailto:/
      // tel:, and paths starting with "/" or "#". That covers every menu saved
      // before this change, and everything MasterMenu (the legacy popup) still
      // writes, so both shapes render from the same function.
      // Lookup order, and why: a folder id is only ever in `folders`, so try that
      // first when the ref looks like one. Otherwise try `pages`, then fall back
      // to the pages held inside each folder — a page nested in a folder is not
      // in the top-level list, and its own id says nothing about the folder it
      // lives in. Matching is on pageId or pageIdentifier via matchesPageRef.
      const getLinkURL = function (link) {
        if (!link || !link.value) return null;
        const value = String(link.value);

        // Executable schemes never reach an href. Returning null makes React
        // omit the attribute entirely, so a javascript:/data:/vbscript: value
        // saved before the picker started rejecting them renders as an inert
        // link instead of running — no data migration needed.
        if (isUnsafeHref(value)) return null;
        if (/^(?:https?:|mailto:|tel:)/i.test(value)) return value;
        if (value.charAt(0) === "/" || value.charAt(0) === "#") return value;

        const cut = value.indexOf("#");
        const ref  = cut === -1 ? value : value.slice(0, cut);
        const frag = cut === -1 ? ""    : value.slice(cut);
        const folderRows = Array.isArray(folders) ? folders : [];

        // 1. The ref is a folder's own id.
        if (ref.indexOf("folder") !== -1) {
          for (let i = 0; i < folderRows.length; i++) {
            if (matchesPageRef(folderRows[i], ref)) return `/${folderRows[i].pageUrl}` + frag;
          }
        }

        // 2. A page in the top-level list. findPageById also descends any
        //    folderPages nested there, which is how the editor's props.navigation
        //    is shaped, and accumulates the parent path.
        const hit = findPageById(pages, ref);
        if (hit) {
          const isHome = hit.page.pageIdentifier === "home" || hit.page.pageIdentifier === "homenew";
          return (isHome ? "/" : `${hit.parentUrl}/${hit.page.pageUrl}`) + frag;
        }

        // 3. A page inside a folder: "/folder/page". Searched recursively so a
        //    folder within a folder still resolves to its full path.
        for (let i = 0; i < folderRows.length; i++) {
          const folder = folderRows[i];
          if (!folder) continue;
          const child = findPageById(folder.folderPages, ref);
          if (child) return `/${folder.pageUrl}${child.parentUrl}/${child.page.pageUrl}` + frag;
        }

        // Not found anywhere: emit the anchor alone rather than a path built from
        // an id, which would 404.
        return frag || null;
      };

      // Recursively render page-menu folders (folderPages). A folder can hold
      // more folders and pages, nested to any depth -> nested flyout submenus.
      // parentUrl = immediate parent folder's pageUrl (used for page hrefs,
      // matching the existing /folder/page pattern). depth guard avoids loops.
      const renderFolderNode = function (item, parentUrl, depth) {
        const isFolder = item.pageid === "folder";
        const kids = (isFolder && item.folderPages && item.folderPages.length && depth < 10) ? item.folderPages : null;
        const href = isFolder
          ? `/${item.pageUrl}`
          : (parentUrl ? `/${parentUrl}/${item.pageUrl}` : `/${item.pageUrl}`);
        const noRouter = isPlugin(item.pageUrl) || (parentUrl && isPlugin(parentUrl));
        return <li key={"fld-" + depth + "-" + item.pageUrl} className={kids ? "dropdown-submenu" : ""}>
          <a className="dropdown-item" href={href} onClick={noRouter ? undefined : (e) => window.routerClick(e)} style={linkStyle}>{item.pageNewid ? item.pageNewid : item.pageName}</a>
          {kids ? (
            <ul className="dropdown-menu">
              {kids.map(function (child, ci) { return renderFolderNode(child, item.pageUrl, depth + 1); })}
            </ul>
          ) : null}
        </li>;
      };

      let nav = pages.map(function(v,i){
        let space = "";
        let activeClass = "";
        let linkTag = <a className={`nav-link ${space} `}  href={`${(autoLoad && i === 0)?"/":`/${v.pageUrl}`}`} onClick={isPlugin(v.pageUrl) ? undefined : (e) => window.routerClick(e)} style={linkStyle}>{v.pageNewid?v.pageNewid:v.pageName}</a>
        if(props.device === "desktop"){
          if (i < 5) {
            if(props.page) {
              if(props.page.pageUrl === v.pageUrl){
                activeClass = "on"
              } 
            }
            else {
              if(i === 0 && props.mode === "edit") {
                activeClass = "on"
              }
            }
          
            if (v.length === 1) {
              space = "m-0";
            }
          
          }
          let folderPages = "";
          let dropdown = "";
          let dropdownToggle = "";
          if(v.folderPages) {
            if(v.folderPages.length) {
              dropdown = "dropdown";
              dropdownToggle = "dropdown-toggle";
              folderPages = <ul className={`dropdown-menu`}>
                {
                  v.folderPages.map(function(val,i){
                    return renderFolderNode(val, v.pageUrl, 1);
                  })
                }
              </ul>
            }
          }
          return  <li className={`nav-item ${dropdown} ${activeClass}`} key={"home-" + i} data-index={i+1}>
          <a className={`nav-link ${dropdownToggle} ${space} `}  href={`${(autoLoad && i === 0)?"/":`/${v.pageUrl}`}`} onClick={isPlugin(v.pageUrl) ? undefined : (e) => window.routerClick(e)} style={linkStyle}>{v.pageNewid?v.pageNewid:v.pageName}</a>
          {folderPages}
        </li>



        }
        else{
          // mobile device: render the folder tree so the sidepanel accordion works
          let mFolderPages = "";
          let mDropdown = "";
          let mToggle = "";
          if(v.folderPages && v.folderPages.length){
            mDropdown = "dropdown";
            mToggle = "dropdown-toggle";
            mFolderPages = <ul className="dropdown-menu">
              {
                v.folderPages.map(function(val,i){
                  return renderFolderNode(val, v.pageUrl, 1);
                })
              }
            </ul>
          }
          return  <li className={`nav-item ${mDropdown}`} key={"home-" + i}>
            <a className={`nav-link ${mToggle}`} href={`${(autoLoad && i === 0)?"/":`/${v.pageUrl}`}`} onClick={isPlugin(v.pageUrl) ? undefined : (e) => window.routerClick(e)} style={linkStyle}>{v.pageNewid?v.pageNewid:v.pageName}</a>
            {mFolderPages}
          </li>
        }

      });

      if (props.device === "desktop") {
        others = <li className="nav-item dropdown d-none" id="othersDropdown">
          <a href="#" className="nav-link others me-0" style={style}>
          {othersText} <span className="icon-down-open"></span>
          </a> 
          <ul className="dropdown-menu" id="othersMenu">
            {
              pages.map(function(v,i){
                return  <li data-index={i+1}>
                  <a className="dropdown-item" href={`/${v.pageUrl}`} onClick={isPlugin(v.pageUrl) ? undefined : (e) => window.routerClick(e)}>{v.pageNewid?v.pageNewid:v.pageName}</a>
                </li>
              })
            }
          </ul>
        </li>
      }

      let isCustomMenu = "";

      // Recursively render a custom-menu node and its children as nested
      // flyout submenus, up to 5 levels deep (depth 1 = first dropdown level).
      const renderMenuNode = function (node, depth, i) {
        const hasChildren = node.data && node.data.length && depth < 5;
        return <li key={"mnode-" + depth + "-" + i} data-index={i + 1} className={hasChildren ? "dropdown-submenu" : ""}>
          <a className="dropdown-item" href={getLinkURL(node)} onClick={clickInternalLink} style={subLinkStyle}>{node.title}</a>
          {hasChildren ? (
            <ul className="dropdown-menu">
              {node.data.map(function (child, ci) { return renderMenuNode(child, depth + 1, ci); })}
            </ul>
          ) : null}
        </li>;
      };

      if(row.properties.customMenu === true) {
        if(row["navigationMenu"].length) {
          if (props.device === "desktop") {
            nav = row["navigationMenu"].map(function(v,i){
              let menuType = "list";
              let menuGridSize = "";
              if(v.data) {
                if(v.data.length){
                  if(v.properties){
                    menuType = v.properties.type === "2" ? 'grid' : 'list';
                    if(v.properties.type === "2"){
                      menuGridSize = v.properties.size; 
                    }
                  }
                }
              }
  
              let foldersPages = "";
              let dropdown = "";
              let dropdownToggle = "";
              if(v.data) {
                if(v.data.length) {
                  dropdown = "dropdown";
                  dropdownToggle = "dropdown-toggle";
                  foldersPages = <ul className={`dropdown-menu dropdown-style-${menuType}`} style={{columnCount : `${menuGridSize}` }}>
                    {
                      v.data.map(function(val,i){
                        return renderMenuNode(val, 1, i);
                      })
                    }
                  </ul>
                }
              }
  
              return <li className={dropdown} data-index={i+1}>
                <a className={`nav-link ${dropdownToggle}`} href={getLinkURL(v)} onClick={clickInternalLink} style={linkStyle}>{v.title}</a>
                {foldersPages}
              </li>
            });
  
  
            others = <li className="nav-item dropdown d-none" id="othersDropdown">
            <a href="#" className="nav-link others me-0" style={style}>
            {othersText} <span className="icon-down-open"></span>
            </a> 
            <ul className="dropdown-menu" id="othersMenu">
              {
                row["navigationMenu"].map(function(v,i){
              let foldersPages = "";
              let dropdown = "";
              if(v.data) {
                if(v.data.length) {
                  dropdown = "dropdown";
                  foldersPages = <ul className="dropdown-menu">
                    {
                      v.data.map(function(val,i){
                        return <li data-index={i+1}><a className={`dropdown-item`} href={getLinkURL(val)} onClick={clickInternalLink} style={subLinkStyle}>{val.title}</a></li>
                      })
                    }
                  </ul>
                }
              }
  
              return <li className={dropdown} data-index={i+1}>
                <a className={`dropdown-item`} href={getLinkURL(v)} onClick={clickInternalLink} style={linkStyle}>{v.title}</a>
                {foldersPages}
                </li>
                })
              }
            </ul>
          </li>
          }
          if(props.mode === "live"){
            if (props.device === "mobile") {
              isCustomMenu = "custom-navigation";
              nav = row["navigationMenu"].map(function(v,i){
                let foldersPages = "";
                if(v.data) {
                  if(v.data.length) {
                    foldersPages = v.data.map(function(val,i){
                      return <li><a className={`dropdown-item text-wrap`} href={getLinkURL(val)} onClick={clickInternalLink} style={{...linkStyle, margin:"0 0 0 10px !important"}}>{val.title}</a></li>
                    })
                  }
                }
                return <>
                <li>
                  <a className={`nav-link`} href={getLinkURL(v)} onClick={clickInternalLink} style={linkStyle}>{v.title}</a>
                </li>
                {foldersPages}
                </>
              });
            }
          }
        }
      }



       
      let stylePro = {background:app.elementBackground(list.properties.navBackground, list.properties.navBackgroundType), padding:app.elementPadding(props.device === "desktop"?list.properties.navPaddingWeb:list.properties.navPadding)}
      if(list.properties.menuBorderColor){
        stylePro = {background:app.elementBackground(list.properties.navBackground, list.properties.navBackgroundType), padding:app.elementPadding(props.device === "desktop"?list.properties.navPaddingWeb:list.properties.navPadding), borderWidth:app.elementPadding(list.properties.menuBorderWidget), borderColor:app.getColor(list.properties.menuBorderColor), borderStyle:list.properties.menuBorderType === "line"?'solid':'dashed'}
      } 
        return <div id={props.id} className={`navbar-collapse d-flex ${type} ${props.classType} w-100`} style={stylePro}>
          <ul className={`navbar-nav fixed-height ${mAuto} ${isCustomMenu}`} style={elementStyle}>
            {nav}
            {others} 
          </ul>
        </div>
    }

    if(list.viewType === "footerNavigation" && props.navigation){ 
      let linkStyle = style;  
      if(props.device === "desktop"){
        linkStyle.margin = data.properties.linkSpacing/2+'vw';
      } 

      let elementStyle = {flexFlow: 'row wrap'};  
      if(data && data.properties.elementSpacing && data.properties.elementSpacing !== undefined){
        if(props.device === "desktop"){
          elementStyle["marginLeft"] = data.properties.elementSpacing/2+'vw'; 
          elementStyle["marginRight"] = data.properties.elementSpacing/2+'vw';
        } 
      }
      
      let showNavigation = "";
      let showNavigationWeb = ""

      if(!list.properties.show){
        showNavigation = "mobile-d-none" 
      }
      if(!list.properties.showWeb){
        showNavigationWeb = "desktop-d-none"
      }

      let mAuto = "d-flex";
       

      let others = null;
      let nav = props.navigation.map(function(v,i){
        let space = "";
        let activeClass = "";
        
        const linkTag = <a className={`nav-link ${space} `}  href={`/${v.pageUrl}`} onClick={(e) => window.routerClick(e)} style={linkStyle}>{v.pageNewid?v.pageNewid:v.pageName}</a>
     
          if (i === 0) {
            space = "ms-0"; 
          } 
          if(typeof window !== 'undefined' && window.location.pathname === '/'+v.pageUrl){
            activeClass = "on"
          } 
          if (v.length === 1) {
            space = "m-0";
          }
        return  <li className={`nav-item ${activeClass}`} key={"home-" + i}>{linkTag}</li>
     
        
      });


      if(data.lang) {
        nav = [
          {key:"terms_use", url:"terms-of-use"},
          {key:"privacy_policy", url:"privacy-policy"}
        ].map(function(v){
          let activeClass = "";
          if(typeof window !== 'undefined' && window.location.pathname === '/'+v.url){
            activeClass = "on"
          } 
          return  <li key={v.key} className={`nav-item ${activeClass}`}>
          <a className={`nav-link`}  href={`/${v.url}`} onClick={(e) => window.routerClick(e)} style={linkStyle}>{data.lang[v.key]}</a>
          </li>
        });
      }

      let stylePro = {background:app.elementBackground(list.properties.navBackground, list.properties.navBackgroundType), padding:app.elementPadding(props.device === "desktop"?list.properties.navPaddingWeb:list.properties.navPadding)}
      if(list.properties.menuBorderColor){
        stylePro = {background:app.elementBackground(list.properties.navBackground, list.properties.navBackgroundType), padding:app.elementPadding(props.device === "desktop"?list.properties.navPaddingWeb:list.properties.navPadding), borderWidth:app.elementPadding(list.properties.menuBorderWidget), borderColor:app.getColor(list.properties.menuBorderColor), borderStyle:list.properties.menuBorderType === "line"?'solid':'dashed'}
      } 
        return <div id={props.id} className={`d-flex ${type} ${props.classType}`} style={stylePro}>
          <ul className={`navbar-nav flex-row ${mAuto} ${showNavigation} ${showNavigationWeb}`} style={elementStyle}>
            {nav}
            {others} 
          </ul>
        </div>
    }

    if(list.viewType === "advanceSocialLinks"){ 
      let memberSocialInfo = ""
      let elementStyle = {};  
      if(props.device === "desktop"){
        if(data !== undefined && data.widgetType === "headerAi"){
          elementStyle.marginLeft = data.properties.elementSpacing/2+'vw';
          elementStyle.marginRight = data.properties.elementSpacing/2+'vw'; 
        }
         
      } 


      let p = list.properties.padding.split(',').reduce((a, b) => parseInt(a) + parseInt(b), 0);
      let f =  parseInt(list.properties.iconSize);  
      if(props.device === "desktop") { 
        p = list.properties.paddingWeb.split(',').reduce((a, b) => parseInt(a) + parseInt(b), 0);
        f = parseInt(list.properties.iconSizeWeb);
      }
      let cornerType = ''
      if(list.properties.cornerType === 'circular'){
        cornerType = '100%'
      }
      else if(list.properties.cornerType === 'rounded'){
        if(props.device === "desktop") {
          cornerType = app.elementPadding(list.properties.cornersWeb)
        }else{
          cornerType = app.elementPadding(list.properties.corners)
        }
        
      } 
  
      let paddingTotal = 0;
      let iconSizeTotal = 0;
      if(p){
        paddingTotal = p
      }
      if(f){
        iconSizeTotal = f
      }
      
      style["width"] = paddingTotal+iconSizeTotal; 
      style["maxWidth"] = paddingTotal+iconSizeTotal; 
      style["height"] = paddingTotal+iconSizeTotal; 
      style["borderRadius"] = cornerType; 
      style["color"] = app.getColor(list.properties.iconColor); 
      style["background"] = app.getColor(list.properties.iconBackground); 
      style["fontSize"] = f; 

      if(props.device === "desktop"){
        if(data !== undefined && data.widgetType === "headerAi"){
          style["marginLeft"] = data.properties.linkSpacing/2+'vw'; 
          style["marginRight"] = data.properties.linkSpacing/2+'vw'; 
        } 
      }

      
      if (list.options) { 
      
        memberSocialInfo = list.options.map(function(v, i) {
          let space = "";
          if (i === 0) {
            if(props.device === "desktop"){
              space = "ms-0";
            } 
          }
          if (i === list.options.length - 1) {
            space = "me-0"; // Apply me-0 to the last element
          }
          if (v.length === 1) {
            space = "m-0";
          }

          let socialLink = null;
          if(v.link) {
            if(v.link !== "") {
              socialLink = v.link;
            }
          }
      
          if(isUploadedIcon(v.iconCss)) {
            return (
              <a href={socialLink} className={`fa ${space}`} target="_blank" key={'key-' + i} style={style}>
                <img src={v.iconCss} alt="" className="uploaded-icon" />
              </a>
            );
          }
          return (
            <a
              href={socialLink}
              className={`fa ${v.iconCss} ${space}`}
              target="_blank"
              key={'key-' + i}
              style={style}
            ></a>
          );
        });
      } 
      html = <div data-show={list.properties.showWeb} id={props.id} className={`${type} ${props.classType} social-header d-flex`} style={elementStyle}>{memberSocialInfo}</div>
  }

  if(list.viewType === "headerIcons"){   
    let p = list.properties.padding.split(',').reduce((a, b) => parseInt(a) + parseInt(b), 0);
    let f =  parseInt(list.properties.iconSize);  
    if(props.device === "desktop") { 
      p = list.properties.paddingWeb.split(',').reduce((a, b) => parseInt(a) + parseInt(b), 0);
      f = parseInt(list.properties.iconSizeWeb);
    }
    let cornerType = ''
    if(list.properties.cornerType === 'circular'){
      cornerType = '100%'
    }
    else if(list.properties.cornerType === 'rounded'){
      if(props.device === "desktop") {
        cornerType = app.elementPadding(list.properties.cornersWeb)
      }else{
        cornerType = app.elementPadding(list.properties.corners)
      }
      
    } 

    let paddingTotal = 0;
    let iconSizeTotal = 0;
    if(p){
      paddingTotal = p
    }
    if(f){
      iconSizeTotal = f
    }
    
    style["width"] = paddingTotal+iconSizeTotal; 
    style["maxWidth"] = paddingTotal+iconSizeTotal; 
    style["height"] = paddingTotal+iconSizeTotal; 
    style["borderRadius"] = cornerType; 
    
    let styleMargin = {};
    if(data && data.properties.elementSpacing && data.properties.elementSpacing !== undefined){
      if(props.device === "desktop"){
        styleMargin["marginLeft"] = data.properties.elementSpacing/2+'vw'; 
        styleMargin["marginRight"] = data.properties.elementSpacing/2+'vw'; 
      }else{
        styleMargin["marginRight"] = '10px'; 
      }
    } 
   

    let isCart = false;
    let category = null;
    if(props.page){
      if (props.page.pageId === "ecommerce" || props.page.pageId === "dinein" || props.page.pageId === "foodcourt" || props.page.pageId === "foodordering" || props.page.pageId === "hyperstore" || props.page.pageId === "digitalstore"){
        isCart = true;
        category = props.page.pageUrl
      }
    } 
    
    let href = null; 
    const pwaIcons = [
      {type:"cart"},
      {type:"notification"},
      {type:"location"}
    ]
    if(props.parentType === "cart"){  
      if(props.mode === "live"){
        href = category+'/viewcart'
      } 
    }

    if(props.parentType === "notification"){  
      if(props.mode === "live"){
        href = "/notification"; 
      } 
    } 
    
    let badgeWrapper = ""; 
    if(props.parent !== "" && props.parentType === "notification" || props.parent !== "" && props.parentType === "cart"){
      badgeWrapper = <div className='badgeWrapper badge badge-primary badge-circle' id={props.parentType} style={{color:app.getColor(list.properties.iconTextColor), background:app.getColor(list.properties.iconTextBgColor)}}>{props.parent}</div>;
    } 

    let locationAddress = "";  
    if(props.parentType === "location"){ 
      if(currentAddress){
        locationAddress = <div style={{marginRight:"10px", fontSize: ".9em", padding: "1px 5px", borderRadius: "4px", background:data.elements.headerIcons.properties.iconBackgroundWeb, color:data.elements.headerIcons.properties.iconColorWeb}}>{currentAddress}</div>;
      }   
      badgeWrapper = ""; 
    }

  

    let location_pop = "";
    let clickElement = null;
    if(app.getMode(props.mode)){
      if(props.parentType === "location"){
        location_pop = props.parent;
        clickElement = (e) => props.showLocationPopup(e)
      }else if(href){
        clickElement = (e) => window.routerClick(e)
      }
    }

    let iconCode = null;
    if(list.icons[props.parentType]) {
      iconCode = list.icons[props.parentType].iconCode;
    }

    let srcType = <i id={props.id} iconid={props.parentType} className={`${type} icons d-flex align-items-center justify-content-center ${iconCode}`} style={style}></i>;
    if(iconCode) {
      if(iconCode.indexOf('https://') !== -1){
        srcType = <img id={props.id} iconId={props.parentType} className={`d-flex align-items-center justify-content-center img-style ${type}`} style={style} src={iconCode}/>
      }
    }
    
    if(data.widgetType  === "headerAi") {
      if(app.isWebsiteBuilder()){
        style["background"] = app.getColor(list.properties.iconBackgroundWeb);
        style["color"] = app.getColor(list.properties.iconColorWeb);
      }
    }
  
    
    let iconbase = ''; 
    if(props.parentType){
      if(props.parentType === "pwaIcons") {
        iconbase = <div id="headerIcons" data-index={0} className="elements headerIcons icons d-flex">
          {
            pwaIcons.map(function(v){
              let iconName = list.icons[v.type].iconCode;
              let iconHtml = <i id={props.id} iconid={props.parentType} className={`d-flex align-items-center justify-content-center ${iconName}`} style={style}></i>;
              if(iconName) {
                if(iconName.indexOf('https://') !== -1){
                  iconHtml = <img id={props.id} iconId={props.parentType} className={`d-flex align-items-center justify-content-center img-style`} style={style} src={iconName}/>
                }
              }
              if(props.device === "desktop") { 
                if(list.icons[v.type].showWeb ===  false) {
                  return null;
                }
              }
              let locationAddress = "";  
              if(v.type === "location"){ 
                if(currentAddress){
                  locationAddress = <div style={{marginRight:"10px", fontSize: ".9em", padding: "1px 5px", borderRadius: "4px", background:data.elements.headerIcons.properties.iconBackgroundWeb, color:data.elements.headerIcons.properties.iconColorWeb}}>{currentAddress}</div>;
                }   
              }
              const aClass = `position-relative ${props.parentType} ${app.iconsFilter(props.pages, v.type)}`;
              if(v.type === "location") {
                return <a onClick={props.showLocationPopup} className={`${aClass}`} style={styleMargin}>
                {iconHtml}
                {locationAddress}
                </a>
              }
              else {
                let url = "/notification";
                if(v.type === "cart") {
                  if(category) {
                    url = `/${category}/viewcart`
                  }
                  else {
                    url = `/viewcart`
                  }
                  if(props.mode === "live") {
                    if(!isCart) {
                      return null;
                    }
                  }
                }
                

                let badgeWrapper = "";
                if(props.mode === "live") {
                  badgeWrapper = <div className='badgeWrapper badge badge-primary badge-circle' id={props.parentType} style={{color:app.getColor(list.properties.iconTextColor), background:app.getColor(list.properties.iconTextBgColor)}}>{v.type === "cart"?props.cartValue:props.notificationValue}</div>
                }

                return <a href={url} onClick={(e) => window.routerClick(e)} className={`${aClass}`} style={styleMargin}>
                  {iconHtml}
                  {badgeWrapper}
                </a>
              }
            })
          }
          {props.locationValue}
        </div>
      }
      else {
        iconbase = <React.Fragment>
          <a href={href} onClick={clickElement} className={`position-relative  ${props.parentType} ${props.classType}`} style={styleMargin}>
            {srcType}
            {badgeWrapper}
            {locationAddress}
          </a>
          {props.locationValue}
        </React.Fragment>
      }
    } 
    
    
    if(!isCart && props.parentType === "cart" && app.getMode(props.mode)){
      return null
    }
   
    html = <div className={`position-relative headerIcons_wrapper d-flex align-items-center justify-content-center ${props.className}`}>
      {iconbase} 
    </div> 

  }


  if(list.viewType === "video"){
     
    let aiClass = "";
    
    let ratio = list.properties.ratio.split('x');
    style.aspectRatio = ratio[0]+' / '+ratio[1];
    if(props.device === "desktop") { 
      if(list.properties.ratioWeb){ 
        ratio = list.properties.ratioWeb.split('x');
        style.aspectRatio = ratio[0]+' / '+ratio[1];
      }
    }

    let imageRatio = list.properties.ratio; 
    if(props.device === "desktop") { 
      if(list.properties.ratioWeb){ 
        imageRatio = list.properties.ratioWeb;
      }
    }

    let video = <React.Fragment>
    <span className="video-overlay iconz-play-button" data-type={list.properties.type}></span>
    <img id={props.id} data-type={list.properties.type} data-embed={list.properties.embed} data-src={list.properties.src} className={`${type} w-100`} src={`https://media.mediadirhub.com/images/image-${imageRatio}.png`} style={{background: `url(${list.properties.thumb}) no-repeat center/cover`}} />
    </React.Fragment>;

    let play = null;
    let sound = null;
    let repeat = null;
    if(list.properties.autoPlay){ 
      play = 'autoPlay'
      sound = 'muted'
    }
    if(list.properties.loop){
      repeat = 'loop'
      sound = 'muted'
    }

    if(app.getMode(props.mode)){
      video = <video data-type={list.properties.type} id="video" controls="controls" controlsList="nodownload" autoPlay={play} muted={sound} loop={repeat} onContextMenu={(e)=>e.preventDefault()}><source src={list.properties.src} type="video/mp4"/></video>;
      if(list.properties.type === "youtube" || list.properties.type === "dailymotion" || list.properties.type === "vimeo"){
        video = <iframe data-type={list.properties.type} data-embed={list.properties.embed} src={`${list.properties.embed}`} allowFullScreen webkitAllowFullScreen mozallowfullscreen msallowfullscreen oallowfullscreen/>
      }
    }
 
    html = <div id={props.id} className={` ${props.classType} ${aiClass} ${type}`} style={style}>
      {video}
  </div>
 

    // html = <div className={`position-relative w-100 ${props.classType} ${isMobileImg} ${isDesktopImg} ${aiClass}`} style={{padding:app.elementPadding(list.properties.paddingWeb), background:app.elementBackground(list.properties.background, list.properties.backgroundType)}}>
    //   <img id={props.id} className={`${type} w-100`} src={`https://media.mediadirhub.com/images/image-${imageRatio}.png`} style={{background: `url(${list.properties.src}) no-repeat center/center`, border:list.properties.borderColor?`1px solid ${app.getColor(list.properties.borderColor)}`:null}} alt={alt} />
     
    // </div> 
  }

    return html
}

export const ListWrap = function(props) { 
  let {data, className, mode, grid, index} = props;
   
  let moveItem = "";
  if(data.items){
    if(data.items.length){
      moveItem = data.items.length
    }
  }
  let gridShow = true;
  if(grid === false){
    gridShow = false
  }
  let isSwiper = data.properties.isSwiper; 
        
  let size = 1;
  if(data.properties.spanWeb) {
      size = data.properties.spanWeb;
  }

  let display = "";
  if(props.data.properties.show === false) {
    display = "d-none"
  }

  let cssClass = "g-4 align-items-stretch justify-content-center "
  if(className){
    cssClass = className
  }  
  
  let rootClass = cssClass; 
  if(data.properties.span && data.properties.spanWeb && gridShow){
    rootClass = `row row-cols-${data.properties.span} row-cols-lg-${data.properties.spanWeb}  ${cssClass}`
  }
 
  if(isSwiper && app.getMode(mode)) {
    return <div className={`swiper h-auto swiper-${index} swiper-${data.properties.indicatorType} moveItem-${moveItem}`} data-size={size}>
        <style>
          {`
            .swiper-${index} .swiper-pagination-bullet {
              background: ${app.getColor(data.properties.indicatorInActiveColor)} !important;
              opacity:1
            }
            
            .swiper-${index} .swiper-pagination-bullet-active { 
              background: ${app.getColor(data.properties.indicatorActiveColor)}  !important;
              opacity:1
            }
            .swiper-line .swiper-pagination-bullet{
              width: 24px;
              border-radius: 10px;
              height: 4px;
            }
          `}
        </style>
        <div className="swiper-wrapper pb-4">
          {props.children}
        </div>
        <div className="swiper-pagination" style={{bottom:'0px'}}></div>
    </div>
  }
  else{
    return <div className={`${rootClass} ${display} moveItem-${moveItem}`}>
      {props.children}
    </div>
  } 
  
}

export const GridWrap = function({children, className, data, index, id, mode, device, swiper, parentClassName}) {
   
  let parentName = '';
  if(parentClassName){
    parentName = parentClassName
  }
    const domEle = useRef();
    if(app.getMode(mode)) {
      return <div className={`${swiper?'swiper-slide':`col ${parentName}`}`}>
        <div id={id} className={`elements-grid position-relative ${className}`} style={app.getStyle(data, device)} ref={domEle} data-index={index}>
        {children}
        </div>
      </div>
    }
    
    return <div className={`col ${parentName} ${app.getClass(data, device)}`}>
          <div id={id} className={`elements-grid position-relative`} ref={domEle} data-index={index}> 
            <div className="action-grid"> 
                <ul className="z_list">
                    <li><a className="editItem tool-tip">{svgIcon.edit}<span className="tooltip-text">{app.getLang("edit")}</span></a></li>
                    <li><a className="gridMoveItem tool-tip" draggable="true">{svgIcon.move}<span className="tooltip-text">{app.getLang("move")}</span></a></li>
                    <li><a className="gridCopyItem tool-tip">{svgIcon.copy}<span className="tooltip-text">{app.getLang("copy")}</span></a></li>
                    <li><a className="gridDeleteItem tool-tip">{svgIcon.delete}<span className="tooltip-text">{app.getLang("remove")}</span></a></li>
                </ul>  
            </div>

          <div className={`overflow-hidden position-relative ${className}`} style={app.getStyle(data, device)} >
            <div className="drop-area">move item on this position</div>
            {children}
          </div>

        </div>
    </div>
  }

  export const ActionWrap = function({children, data, index, widgetType, mode, device, lastIndex}) {
    const [status, setStatus] = useState(false);
    const [success, setSuccess] = useState(false); 
    const domEle = useRef();
     
  
  useEffect(() => {
      if(app.aiBackground(mode, data.properties.background)) {
          const a = setInterval(function(){
            if(readyImages("c", data.properties.background)) {
                clearInterval(a);
                updateSuccess(true);
            }
          }, 1000);
          if(readyImages("c", data.properties.background)) {
              clearInterval(a);
              updateSuccess(true);
          }
      }
   }, []);
  
   const readyImages = function(type, image) {
      let data = [];
      if(localStorage.getItem("aiReadyImages")) {
          data = JSON.parse(localStorage.getItem("aiReadyImages"))
      }
      if(type === "p") {
          data.push(image);
          localStorage.setItem("aiReadyImages", JSON.stringify(data));
      }
      else {
          return ((data.indexOf(image) !== -1)?true:false)
      }
    }
   const updateSuccess = function() {
      setSuccess(true);
       setTimeout(function(){
          setStatus(true);
       }, 600)
   }

    useEffect(() => {
      if(!app.getMode(mode)) {
        if(window.clickElement) {
          domEle.current.querySelectorAll(".elements-grid").forEach(function(ele, ind){
              ele.setAttribute("data-index", index);
              ele.setAttribute("data-grid", ind);

              ele.querySelectorAll(".elements").forEach(function(v){
                  v.setAttribute("data-grid", ind);
              });
          });
          domEle.current.querySelectorAll(".add-section").forEach(function(ele){
              ele.setAttribute("data-index", index);
          });
        }
      } 
    }, []);
  
    useEffect(() => { 
      if(!app.getMode(mode)) {
        if(window.clickElement) {
            domEle.current.querySelectorAll(".elements").forEach(function(ele){
                ele.setAttribute("data-index", index);
            });
            domEle.current.querySelectorAll(".elements-grid").forEach(function(ele, ind){
              ele.setAttribute("data-index", index);
              ele.setAttribute("data-grid", ind);
              ele.querySelectorAll(".elements").forEach(function(v){
                  v.setAttribute("data-grid", ind);
                  v.setAttribute("data-id", ele.getAttribute("id"));
              });
              ele.querySelectorAll(".action-grid a").forEach(function(eleA){
                  eleA.setAttribute("data-index", index);
                  eleA.setAttribute("data-grid", ind);
                  eleA.setAttribute("data-id", ele.getAttribute("id"));
                  ["click"].forEach(function(v){
                    eleA.addEventListener(v, window.actionClick);
                  })
              });
              ["dragstart", "dragend"].forEach(function(v){
                ele.querySelector(".action-grid a.gridMoveItem").addEventListener(v, window.actionClick);
              })
               ele.querySelector(".drop-area").setAttribute("data-index", index);
              ele.querySelector(".drop-area").setAttribute("data-grid", ind);
              ele.querySelector(".drop-area").setAttribute("data-id", ele.getAttribute("id"));
              ["drop", "dragover", "dragleave"].forEach(function(v){
                ele.querySelector(".drop-area").addEventListener(v, window.actionClick);
                
              })
            });
           
          domEle.current.querySelectorAll(".add-section").forEach(function(ele){
            ele.setAttribute("data-index", index);
          });

          domEle.current.querySelectorAll(".elements").forEach(function(ele){
            ele.setAttribute("data-index", index);
            let isFnction = ["click", "mouseover", "focus", "dblclick"];
           
            isFnction.forEach(function(v){
              ele.addEventListener(v, window.clickElement);
            })
          });
          domEle.current.addEventListener("mouseover", window.clickElement);
          // domEle.current.querySelectorAll(".block-area").forEach(function(ele){
          //   ["mouseover"].forEach(function(v){
          //       ele.addEventListener(v, window.clickElement);
          //   })
          // });
        }
      }
      
    });
 
     

    let style = app.getStyle(data, device); 
    if(widgetType === "headerAi") {
      if(app.isWebsiteBuilder()){
        style["background"] = app.elementBackground(data.properties.backgroundWeb,data.properties.backgroundWebType);
      }
    }
   


    let loader = "";
    if(app.aiBackground(mode, data.properties.background)) {
      if(!status) {
        style["background"] = `#00000000`;
      }
      loader = <div className={`w-100 h-100 ${success?'image-success':''}  ${status?'image-ready':''}`}>
        <div className="loader-wrapper d-flex align-items-center justify-content-center">
        <span className="new-loader sm-loader"></span>
        </div>
        <span className="generating">generating</span>
        <span className="succeeded">succeeded</span>
      </div>
    }
   
    if(app.getMode(mode)) {
      return <section className={`block container-fluid position-relative ${app.getClass(data, device)}`} style={style} ref={domEle} data-index={index} widget-type={widgetType} widget-id={data.viewId} id={data.viewId}>
          <div className={`main-wrapper ${data.properties.isFluid} p-0`}>
              {children}
          </div>
          {loader}
      </section>
    }
     

    let isHideAll = app.isHideAll(data, device);

    return <section className={`block container-fluid position-relative ${app.getClass(data, device)} isHideAll-${isHideAll}`} style={style} ref={domEle} data-index={index} data-lastindex={lastIndex} widget-type={widgetType}>
      {app.isMobile()?<button className="close-popup modal-close position-relative ic_ai_icon_game_setting_8 root-setting editBypass_mobile" data-index={index} onClick={window.actionClick}></button>:null}
      <div className="block-area" data-index={index}></div>
     
      <div className={`main-wrapper ${data.properties.isFluid} p-0`}>
      {children}
      </div>
      <button className="btn btn-lg btn-outline-dark add-section top" data-index={0} onClick={window.actionClick}>{app.getLang("add_section")}</button>
      <button className="btn btn-lg btn-outline-dark add-section bottom" data-index={0} onClick={window.actionClick}>{app.getLang("add_section")}</button>
    </section>
  }


export const AlertModal = (props) => {
    function remove() {
      const modalElement = document.querySelector('.modal.alertModal');
      if (modalElement) {
        modalElement.remove();
      }
    }
   
    return (
      <div className="modal alertModal" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md deleteModal">
          <div className="modal-content h-auto" style={{ minHeight: "auto" }}>
            <div className="modal-body p-4 pb-0" style={{ minHeight: 'inherit' }}>
              <h6 className='fw-bold'>{props.title}</h6>
              <small>{props.summary}</small>
            </div>
            <div className="modal-footer border-0">
              <button type="button" className="btn del-btn" onClick={remove}>{app.getLang("cancel")}</button> 
            </div>
          </div>
        </div>
      </div>
    );
  }

  export const WebPreview = (props) => {
    function remove() {
      const modalElement = document.querySelector('.modal.WebPreviewModal');
      if (modalElement) {
        modalElement.remove();
      }
    }
   
    return (
      <div className="modal WebPreviewModal m-0 text-center" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md mw-100 h-100 m-0">
          <div className="modal-content h-100" style={{borderRadius:'0'}}>
            <div className="modal-body p-2 h-100">
              {/* <h1>Nitin</h1> */}
              <img src={props.url} className='w-100 mw-100'/>
            </div>
            <div className="modal-footer border-0">
              <button type="button" className="btn del-btn" onClick={remove}>{app.getLang("cancel")}</button> 
            </div>
          </div>
        </div>
      </div>
    );
  }
  